function createAction(type, payload = undefined) {
    return payload === undefined ? {type} : {type, payload};
}

export default createAction;
